const reducer = (state, { type, payload }) => {
	// console.log(type, payload);
	switch (type) {
		case "SHOW_POPUP":
			return {
				...payload,
				visible: true,
			}

		case "CLOSE_POPUP":
			return {
				visible: false,
			}

		case "SET_DATA":
			let data = state.data || {};
			return {
				...state,
				data: {
					...data,
					...payload,
				}
			}

		default:
			return state
	}
}

export default reducer;